import React, { useRef } from "react";
import { Button } from "@mui/material";
import { motion } from "framer-motion";
import Products from "./Products";
import XFactor from "./XFactor"; // Import the XFactor component
import Affiliation from "./Affiliation"; // Import the Affiliation component
import ContactUs from "./ContactUs"; // Import the ContactUs component

const Homepage = () => {
    const productSectionRef = useRef(null);

    const handleExploreClick = () => {
        productSectionRef.current.scrollIntoView({ behavior: "smooth" });
    };

    return (
        <div>
            <div className="w-full h-screen flex items-center justify-center bg-gradient-to-r from-amber-50 to-yellow-100 relative">
                <motion.div
                    className="absolute inset-0"
                    style={{
                        backgroundImage: "url('/banner.png')",
                        backgroundSize: "cover",
                        backgroundPosition: "center",
                    }}
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ duration: 5 }}
                />
                <Button
                    variant="contained"
                    className="z-10"
                    style={{
                        backgroundColor: "#333",
                        color: "#fff",
                        position: "absolute",
                        bottom: "100px",
                        right: "350px",
                        border: "2px solid #555",
                        borderRadius: "8px",
                        padding: "10px 20px",
                        boxShadow: "0 4px 8px rgba(0, 0, 0, 0.3)",
                        transition: "transform 0.3s, box-shadow 0.3s",
                    }}
                    onMouseEnter={(e) => {
                        e.target.style.transform = "scale(1.1)";
                        e.target.style.boxShadow = "0 6px 12px rgba(0, 0, 0, 0.5)";
                    }}
                    onMouseLeave={(e) => {
                        e.target.style.transform = "scale(1)";
                        e.target.style.boxShadow = "0 4px 8px rgba(0, 0, 0, 0.3)";
                    }}
                    onClick={handleExploreClick}
                >
                    Explore
                </Button>
                <style jsx>{`
                    @media (max-width: 768px) {
                        .z-10 {
                            right: 100px !important;
                        }
                    }
                `}</style>
            </div>

            <div
                className="relative"
                ref={productSectionRef}
            >
                <div
                    className="absolute inset-x-0 top-0 h-16 bg-gradient-to-r from-yellow-100 to-amber-50"
                    style={{
                        clipPath: "polygon(0 0, 100% 0, 100% 100%, 0 50%)",
                    }}
                />
                <Products />
            </div>

            {/* X Factor Section */}
            <XFactor />

            {/* Affiliation Section */}
            <Affiliation />

            {/* Contact Us Section */}
            <ContactUs />
        </div>
    );
};

export default Homepage;